var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"id":"navigation"}},[_c('User')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }